import useSWR from 'swr';
import { getStatistics } from 'api/account';

const STATISTICS_KEY = ['account-statistics'];

export const useStatistics = () => {
  const { data, error, mutate, isLoading } = useSWR(
    STATISTICS_KEY,
    () => getStatistics(),
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      refreshInterval: 30000,
      dedupingInterval: 5000,
    },
  );

  return {
    data: data?.data,
    isLoading,
    error,
    mutate,
  };
};
